import { defineCustomElement } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import Bubble from './features/Bubble/components/Bubble.vue'
import { defaultBubbleProps } from './constants'
import styles from './styles.css?inline'

setActivePinia(createPinia())

// @ts-expect-error  vendor
const MyHotspot = defineCustomElement({ ...Bubble, props: defaultBubbleProps, styles: [styles] })

export function registerWebComponents() {
  if (typeof window === 'undefined')
    return
  customElements.define('netwatch-bubble', MyHotspot)
}
